import React, { useEffect, useState } from "react";
import { Alert, Button, Card, CardBody, Container, Input, Spinner, Table } from "reactstrap";

import { apiFetch, API } from "../../services/api";
import { readError } from "../../helpers/whatsappTemplates";
import { GuideLinks } from "./GuideLinks";

// Demandes de modification des coordonnées de facturation : « Appliquer » écrit dans le client Qonto associé.
export function BillingRequests() {
    const [list, setList] = useState(null);
    const [error, setError] = useState(null);
    const [reasons, setReasons] = useState({});
    const [busy, setBusy] = useState("");

    const load = () => apiFetch(API.back + "/display-billing-requests", { market: false })
        .then(async (r) => { if (!r.ok) throw new Error(await readError(r)); return r.json(); })
        .then(setList)
        .catch((e) => { setError(e.message); setList([]); });
    useEffect(() => { load(); }, []);

    const decide = async (r, action) => {
        const key = r.partnerKey + r.at;
        if (action === "reject" && !(reasons[key] || "").trim()) { setError("Motif de refus obligatoire."); return; }
        setBusy(key);
        setError(null);
        const res = await apiFetch(API.back + "/display-billing-request", { method: "POST", market: false,
            body: JSON.stringify({ partnerKey: r.partnerKey, at: r.at, action, reason: reasons[key] || "" }) });
        setBusy("");
        if (!res.ok) { setError(await readError(res)); return; }
        load();
    };

    return (
        <Container fluid className="p-0">
            <h1 className="h3 mb-1">Coordonnées de facturation à valider</h1>
            <GuideLinks />
            {error && <Alert color="danger">{error}</Alert>}
            <Card><CardBody>
                {list === null ? <Spinner /> : list.length === 0 ? <p className="mb-0 text-muted">Aucune demande en attente.</p> : (
                    <Table size="sm" className="mb-0">
                        <thead><tr><th>Partenaire</th><th>Demandé par</th><th>Nouvelles coordonnées</th><th>Motif (si refus)</th><th /></tr></thead>
                        <tbody>
                            {list.map((r) => {
                                const key = r.partnerKey + r.at;
                                const w = r.wanted || {};
                                return (
                                    <tr key={key}>
                                        <td>{r.partnerKey} ({r.market})</td>
                                        <td>{r.email}<div className="small text-muted">{new Date(r.at.split("#")[0]).toLocaleString("fr-FR")}</div></td>
                                        <td className="small"><b>{w.name}</b><br />{w.address?.street}, {w.address?.zipCode} {w.address?.city} ({w.address?.country})<br />
                                            {[w.email, w.vatNumber && `TVA ${w.vatNumber}`, w.taxId && `SIRET ${w.taxId}`].filter(Boolean).join(" · ")}</td>
                                        <td><Input bsSize="sm" value={reasons[key] || ""} onChange={(e) => setReasons({ ...reasons, [key]: e.target.value })} /></td>
                                        <td className="text-right text-nowrap">
                                            <Button size="sm" color="primary" disabled={busy === key} onClick={() => decide(r, "apply")}>Appliquer dans Qonto</Button>{" "}
                                            <Button size="sm" color="link" disabled={busy === key} onClick={() => decide(r, "reject")}>Refuser</Button>
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </Table>
                )}
            </CardBody></Card>
        </Container>
    );
}
